import { Button } from "components/ui/Button";
import { Dialog } from "components/ui/Dialog/Dialog";
import { Select } from "components/ui/Select/Select";

import styles from "./CancelReviewModal.module.css";

/**
 * BE hardcodes the HL7 cancellation reason to "Incorrect Programme" — there is
 * no reason field in the cancel API. This select is display-only (disabled) so
 * the GP can see what reason will be sent; it is never submitted.
 */
const CANCELLATION_REASON_OPTIONS = [
  { label: "Incorrect Programme", value: "INCORRECT_PROGRAMME" },
];
const CANCELLATION_REASON_VALUE = "INCORRECT_PROGRAMME";

export const CancelReviewModal = ({
  isOpen,
  isCancelling = false,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose} title="Cancel Review" width={480}>
      <div className={styles.body}>
        <p className={styles.description}>
          This sends a cancellation message to HealthLink for this previously
          submitted review. Are you sure you want to cancel it?
        </p>
        <div className={styles.field}>
          <label className={styles.label}>Cancellation reason</label>
          <Select
            options={CANCELLATION_REASON_OPTIONS}
            value={CANCELLATION_REASON_VALUE}
            onChange={() => {}}
            placeholder=""
            disabled
            fullWidth
          />
        </div>
        <div className={styles.actions}>
          <Button variant="outline" disabled={isCancelling} onClick={onClose}>
            Keep review
          </Button>
          <Button disabled={isCancelling} onClick={onConfirm}>
            {isCancelling ? "Cancelling…" : "Cancel review"}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
